export default "__VITE_ASSET__5b687896__"